import Login from './Login'
import ForgotPassword from './ForgotPassword'
import ChangePassword from './ChangePassword'
// import Register from './Register';

export default {
  Login,
  ForgotPassword,
  ChangePassword
  // Register,
}



// WEBPACK FOOTER //
// ./src/components/pages/auth/index.js